import { createAction, props, union } from '@ngrx/store';

/* eslint-disable max-len */

export const reset = createAction('[Error Log] Reset', props<Record<string, unknown>>());
export const add = createAction('[Error Log] Add', props<{
    error: string;
}>());

const all = union({
    add,
    reset,
});
export type Actions = typeof all;
